import PropTypes from "prop-types";
import React from "react";
import styled, { keyframes } from "styled-components";

const imageLoad = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const StyledSpan = styled.span`
  background-color: ${props => props.theme.colors.lightGrey};
  border-radius: 45px;
  display: block;
  height: 90px;
  overflow: hidden;
  width: 90px;
  border-color: ${props => props.theme.colors.lightGrey};
  border-style: solid;
  border-width: 1px;
  flex-shrink: 0;

  img {
    animation: ${imageLoad} 0.3s ease-in 1;
    color: ${props => props.theme.colors.lightGrey};
    display: block;
    height: 100%;
    width: 100%;
  }
`;

function CarerImage({ carer, className }) {
  if (!carer || !carer.image || !carer.image.profile) {
    return <StyledSpan className={`no-image ${className}`} />;
  }

  return (
    <StyledSpan className={`carer-image ${className}`}>
      <img src={carer.image.profile} alt={carer.display_name} />
    </StyledSpan>
  );
}

CarerImage.propTypes = {
  carer: PropTypes.shape({
    image: PropTypes.shape({
      profile: PropTypes.string
    }),
    name: PropTypes.string
  }).isRequired,
  className: PropTypes.string
};

CarerImage.defaultProps = {
  className: ""
};

export default CarerImage;
